exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@use 'sass:map';.no-scroll[data-v-4d7cbc20]{position:relative;z-index:100;overflow:hidden}.illustration[data-v-4d7cbc20]{width:206px;height:179px}\n", ""]);
